import { useState, useEffect } from "react";
import { Button } from "@/components/ui/button";
import { useLanguage } from "@/contexts/LanguageContext";

const translations = {
  en: {
    message: "We use cookies to enhance your browsing experience and analyze our traffic. By clicking 'Accept All', you consent to our use of cookies.",
    acceptAll: "Accept All",
    rejectAll: "Reject All",
    settings: "Cookie Settings",
    privacyLink: "Privacy Policy"
  },
  tr: {
    message: "Tarama deneyiminizi geliştirmek ve trafiğimizi analiz etmek için çerezler kullanıyoruz. 'Tümünü Kabul Et' seçeneğine tıklayarak çerez kullanımımızı kabul etmiş olursunuz.",
    acceptAll: "Tümünü Kabul Et",
    rejectAll: "Tümünü Reddet",
    settings: "Çerez Ayarları",
    privacyLink: "Gizlilik Politikası"
  },
  ar: {
    message: "نستخدم ملفات تعريف الارتباط لتحسين تجربة التصفح وتحليل حركة المرور. بالنقر على 'قبول الكل'، فإنك توافق على استخدامنا لملفات تعريف الارتباط.",
    acceptAll: "قبول الكل",
    rejectAll: "رفض الكل",
    settings: "إعدادات ملفات تعريف الارتباط",
    privacyLink: "سياسة الخصوصية"
  }
};

export const CookieConsent = () => {
  const [isVisible, setIsVisible] = useState(false);
  const { language } = useLanguage();
  const t = translations[language as keyof typeof translations] || translations.en;

  useEffect(() => {
    const consent = localStorage.getItem("cookie-consent");
    if (!consent) {
      // Small delay to avoid layout shift on initial load
      const timer = setTimeout(() => setIsVisible(true), 1000);
      return () => clearTimeout(timer);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem("cookie-consent", "accepted");
    setIsVisible(false);
  };

  const handleReject = () => {
    localStorage.setItem("cookie-consent", "rejected");
    setIsVisible(false);
  };

  if (!isVisible) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 p-4 bg-background/95 backdrop-blur-sm border-t border-border shadow-lg animate-fade-in">
      <div className="container mx-auto max-w-6xl">
        <div className="flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-sm text-muted-foreground text-center md:text-left flex-1">
            {t.message}{" "}
            <a href="/privacy-policy" className="text-primary hover:underline">
              {t.privacyLink}
            </a>
          </p>
          <div className="flex items-center gap-2 shrink-0">
            <Button variant="outline" size="sm" onClick={handleReject}>
              {t.rejectAll}
            </Button>
            <Button size="sm" onClick={handleAccept}>
              {t.acceptAll}
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};
